export class Treatment {
  type?: string;
  "created_at": string;
  "deleted_at": string;
  "detection": any;
  "detection_time": any;
  "drug_name": string;
  // 'drug_brand': string;
  "horse_id": number;
  "id": number;
  "other_route": string;
  "prescriptions": [Prescription];
  "reason": string;
  "request": any;
  "request_id": number;
  "route": string;
  "status": string;
  "updated_at": string;
  "vetclinic_id": string;
  "withdrawal": string;
  "start_date": string;
  "frequency": any;
  "drug": any;
  "quantity": number;
  "other_quantity": string;
  "quantity_measure": any;
  "duration": number;
  "src": any;
  "srcs": any[];
  "horse": any;

  administer?: TreatmentAdminister;

  constructor(obj?: Administer & any) {
    // tslint:disable-next-line:no-unused-expression
    !!obj && Object.assign(this, obj);
    this.administer = new TreatmentAdminister();
  }
}

export class Administer {
  id?: number;
  text?: string;

  constructor(obj?: Administer & any) {
    // tslint:disable-next-line:no-unused-expression
    !!obj && Object.assign(this, obj);
  }
}

export class TreatmentAdminister {
  id?: number;
  contact_name?: string;
  contact_info?: string;
  treatment_id: number;
  user_id?: number;
  user?: User;

  constructor(obj?: TreatmentAdminister & any) {
    // tslint:disable-next-line:no-unused-expression
    !!obj && Object.assign(this, obj);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/treatment.ts